module.exports = __webpack_public_path__ + "images/emoji/beetle.5f6b6bcf59e49c755953.png";